<template>
  <DatePicker
    :rules="rules"
    :locale="{ masks: { weekdays: 'WW' } }"
    mode="date"
    expanded
    class="!border-none !py-0 !px-0.5"
  />
</template>

<script setup>
import { ref } from "vue";
import { DatePicker } from "v-calendar";

const rules = ref([
  {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  },
]);
</script>

<style lang="scss">
.vc-container {
  @apply font-sans;

  .vc-title {
    @apply capitalize font-bold fg-secondary text-style-base;
  }

  .vc-base-icon {
    @apply button-secondary-gray-fg;
  }

  .vc-weekday {
    @apply text-secondary capitalize font-medium text-style-sm;
  }

  .vc-day {
    @apply text-secondary font-normal text-style-sm;
  }

  .vc-blue {
    @apply hover:bg-brand-solid_hover hover:text-white font-medium;
  }

  .vc-highlight-content-solid {
    @apply bg-brand-solid text-white;
  }
}
</style>
